import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
var defaultValue = {
  navBar: false,
  toolBar: false
};
/**
 * @type {import('./types').PageContext} Contains the page context.
 */

export var PageContext = React.createContext([defaultValue, null]);

var usePageElement = function usePageElement(pageElementName) {
  var _React$useContext = React.useContext(PageContext),
      _React$useContext2 = _slicedToArray(_React$useContext, 2),
      state = _React$useContext2[0],
      setState = _React$useContext2[1];

  React.useEffect(function () {
    setState(function (prevState) {
      return _objectSpread({}, prevState, _defineProperty({}, pageElementName, true));
    });
    return function () {
      setState(function (prevState) {
        return _objectSpread({}, prevState, _defineProperty({}, pageElementName, false));
      });
    };
  }, [pageElementName]);
  return state;
};
/** Adds a flag that Page.NavBar has been rendered */


export var usePageNavBar = function usePageNavBar() {
  return usePageElement('navBar');
};
/** Adds a flag that Page.ToolBar has been rendered */

export var usePageToolBar = function usePageToolBar() {
  return usePageElement('toolBar');
};
/** Read Page.* rendered flags */

export var usePageContext = function usePageContext() {
  var _React$useContext3 = React.useContext(PageContext),
      _React$useContext4 = _slicedToArray(_React$useContext3, 1),
      state = _React$useContext4[0];

  return state;
};
/**
 * @param {import('./types').PageContextProvider} props
 */

var PageContextProvider = function PageContextProvider(_ref) {
  var children = _ref.children;
  var state = React.useState(defaultValue);
  return React.createElement(PageContext.Provider, {
    value: state
  }, children);
};

export default PageContextProvider;